import React from "react";
import { QueryObserverResult } from "react-query";
import {
  COLOURS,
  MigrationSetImport,
  MigrationSetWithImports,
} from "../../shared";
import { Card } from "../card";
import { User } from "lucide-react";

interface CardMatterRelationshipProps {
  currentMigrationSetId: number;
  data: { imports: MigrationSetImport[] } | undefined;
  cardsState: Record<string, any>;
  disableButtonAccess: boolean;
  refetchMigrationSet: () => Promise<
    QueryObserverResult<MigrationSetWithImports, unknown>
  >;
}

export const CardMatterRelationship: React.FC<CardMatterRelationshipProps> = ({
  currentMigrationSetId,
  data,
  cardsState,
  disableButtonAccess,
  refetchMigrationSet,
}) => {
  return (
    <Card
      image={
        <User
          color={COLOURS.cardIconColor}
          strokeWidth={2}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        />
      }
      importType="matterRelationship"
      templateKey="matterRelationshipImport"
      fileName="matterRelationship.csv"
      migrationSetId={currentMigrationSetId}
      migrationSetImport={data?.imports.find(
        (i) => i.importType === "matterRelationship",
      )}
      headerText="Matter Roles"
      description="Can be used to associate additional Contacts with a Matter. A Role can be specified for each Contact."
      cardState={cardsState["matterRelationship"]}
      disableButtonAccess={disableButtonAccess}
      refetchMigrationSet={refetchMigrationSet}
    />
  );
};
